export class contentEditableController {
    load = () => {}

    save = () => {
        let results = {};
        results.why = window['mission'].fields.why.wrapper.find('.note-content').text();
        return results;
    }
}
